import type { StructuralDecorator } from "../decorator.js";
import type { Asked, Rule } from "../rules.js";
import type { AnswersOf, ItemKeyOf, ModulesOf, TypedBy } from "../typedBy.js";

/**
 * When one item is asked, as a rule over the answers typed by the modules it
 * is typed by, as `checkOf` types a check, or `never`; the form is refused where the item is
 * one the instrument requires.
 */
export const showWhen = <Typing extends TypedBy>(
  _typedBy: Typing,
  item: ItemKeyOf<ModulesOf<Typing>>,
  when: Rule<AnswersOf<ModulesOf<Typing>>> | "never",
): StructuralDecorator => ({
  kind: "structural",
  item: (view) =>
    view.at.item === item
      ? {
          ...view,
          // As for `checkOf`: every answer handed over is one the stored
          // schema accepted, so it is never outside its key's response type.
          asked: when as Asked,
        }
      : view,
});
